import React, { useEffect } from 'react';
import { useHasOrderedBeforeLazyQuery } from 'src/gqlReactTypings.generated.d';
import { useBecomeATaster } from 'src/pages/consumer/become-a-taster/useBecomeATaster';
import { Modal } from 'src/shared/design-system/Modal';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { AlreadyOrdered } from './AlreadyOrdered';
import { TrialShefModal } from './TrialShefModal';

interface TrialShefModalProps {
  isTrialShef: boolean;
  shefId: string;
  shefName: string;
  shefImageUrl?: string | null;
  isEditingOrder: boolean;
  goToExploreOnAccept?: boolean;
}
export const TrialShefModals: React.FC<TrialShefModalProps> = ({
  isTrialShef,
  shefId,
  shefName,
  shefImageUrl,
  isEditingOrder,
  goToExploreOnAccept,
}) => {
  const { isTasteTester, loading, becomeATaster } = useBecomeATaster();

  const [currentUser] = useCurrentUser();
  const [query, { data, loading: ordersLoading }] = useHasOrderedBeforeLazyQuery();

  useEffect(() => {
    if (currentUser) {
      query({
        variables: {
          shefId,
          userId: currentUser.id,
        },
      });
    }
  }, [currentUser, query, shefId]);

  const isCurrentUser = shefId === currentUser?.id;
  if (!isTrialShef || isEditingOrder || isCurrentUser) {
    return null;
  }

  const hasOrderedBefore = !ordersLoading && data && (data.orders.count ?? 0) > 0;
  if (hasOrderedBefore) {
    return (
      <Modal isShowing={true}>
        <AlreadyOrdered shefName={shefName} />
      </Modal>
    );
  }

  if (isTasteTester || loading) {
    return null;
  }

  return (
    <TrialShefModal shefImageUrl={shefImageUrl} onHide={() => becomeATaster({ goToExplore: goToExploreOnAccept })} />
  );
};
